/* tslint:disable */
/* eslint-disable */
export enum DigitalWalletEnum {
  GooglePay = 'GooglePay',
  ApplePay = 'ApplePay',
  PayPal = 'PayPal',
  Venmo = 'Venmo'
}
